var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomCheck = function SvgCustomCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.609 5.241c.456.373.523 1.045.15 1.501l-8.953 10.942a2.133 2.133 0 0 1-2.93.356l-3.45-2.587a1.067 1.067 0 1 1 1.28-1.706l3.45 2.586 8.952-10.942a1.067 1.067 0 0 1 1.5-.15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.609 5.241c.456.373.523 1.045.15 1.501l-8.953 10.942a2.133 2.133 0 0 1-2.93.356l-3.45-2.587a1.067 1.067 0 1 1 1.28-1.706l3.45 2.586 8.952-10.942a1.067 1.067 0 0 1 1.5-.15Z",
    stroke: "currentColor"
  })));
};

export default SvgCustomCheck;